import { useState } from 'react'
import { Link, useRouterState } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { Menu } from 'lucide-react'
import { Drawer } from '@shared/design-system/ui'
import { useFeatureFlag } from '@shared/feature-flags/useFeatureFlag'
import { useReferralAccess } from '@features/referrals/api/referrals'
import { recuperaAiStatusQuery } from '@features/recupera-ai'
import { bottomNavItems, mobileMoreNavItems, navItemMatchesPath } from './nav-items'
import {
  bottomNav,
  bottomNavButton,
  bottomNavItem,
  mobileMoreItem,
  mobileMoreList,
} from './AppShell.css'

export function BottomNav() {
  const referralsEnabled = useFeatureFlag('referralProgram')
  const recuperaAiEnabled = useFeatureFlag('recuperaAi')
  const membersAreaEnabled = useFeatureFlag('areaDeMembros')
  const access = useReferralAccess()
  const recuperaStatus = useQuery({ ...recuperaAiStatusQuery(), enabled: recuperaAiEnabled })
  const recuperaAiActive =
    recuperaAiEnabled &&
    recuperaStatus.data?.is_active === true &&
    (recuperaStatus.data?.active_product_count ?? 0) > 0
  const moreItems = mobileMoreNavItems
    .filter((item) => {
      if (item.to === '/area-membros') return membersAreaEnabled
      if (item.to === '/indicacoes') {
        return referralsEnabled && access.data?.enabled === true && !access.isError
      }
      return true
    })
    .filter((item) => item.to !== '/recupera-ai' || recuperaAiActive)
  const [moreOpen, setMoreOpen] = useState(false)
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const moreActive = moreItems.some((item) => navItemMatchesPath(item.to, pathname))

  return (
    <>
      <nav className={bottomNav} aria-label="Navegação principal" data-testid="bottom-nav">
        {bottomNavItems.map((item) => (
          <Link key={item.to} to={item.to} className={bottomNavItem}>
            <item.icon size={20} />
            <span>{item.label}</span>
          </Link>
        ))}
        <button
          type="button"
          className={`${bottomNavItem} ${bottomNavButton}`}
          data-status={moreActive ? 'active' : undefined}
          aria-haspopup="dialog"
          aria-expanded={moreOpen}
          onClick={() => setMoreOpen(true)}
        >
          <Menu size={20} />
          <span>Mais</span>
        </button>
      </nav>
      <Drawer
        open={moreOpen}
        onClose={() => setMoreOpen(false)}
        title="Mais áreas"
        description="Acesse as demais áreas da sua conta."
        size="compact"
        variant="navigation"
        placement="bottom"
      >
        <nav className={mobileMoreList} aria-label="Outras áreas da conta">
          {moreItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={mobileMoreItem}
              onClick={() => setMoreOpen(false)}
            >
              <item.icon size={19} />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
      </Drawer>
    </>
  )
}
